import { IComponentOptions, IController } from 'angular';
import * as _ from 'lodash';
import { ISdcStore } from 'src/app/sdc/flux/sdc-store.interface';
import { ISorterColumnService } from 'src/app/shared/sorter-column/sorter-column.service';

import { SorterColumnDataType } from '../../../../../ng2/shared/constants/sorter-column-data-type.constant';
import nvSdcModule from '../../../nv.sdcModule.module';
import { SdcActionsService } from './../../../flux/sdc-actions.service';

class NvGridBulkEditorCtrl implements IController {
  static $inject = ['SDCStore', 'sdcActions', 'SorterColumn', 'Student', '$mdDialog', 'ErrorModal'];

  hasSelectedStudents: boolean;
  columns: string[];
  selectedColumn: string = null;
  items = null;
  newValue = null;
  selectedStudentIds: string[];
  isSaving = false;

  constructor(
    private SDCStore: ISdcStore,
    private sdcActions: SdcActionsService,
    private sorterColumn: ISorterColumnService,
    private Student,
    private $mdDialog,
    private ErrorModal,
  ) {
    this.hasSelectedStudents = SDCStore.getSelectedStudentIds().length > 0;
    this.columns = this.sorterColumn.getSorterColumnHumanNames({ editable: true });

    this.selectedStudentIds = SDCStore.getSelectedStudentIds();
  }

  selectedColumnChange(newHuman: string) {
    if (!newHuman) return;

    const sorterCol = this.sorterColumn.getByHumanName(newHuman);
    this.newValue = null;

    if (sorterCol.dataType === SorterColumnDataType.BOOLEAN_YES_NO) {
      // Since a checkbox doesn't have an "unset" state, BOOLEAN_YES_NO columns get a default data type
      // to avoid user confusion. For the rest of the column types, the user needs to manipulate the UI before
      // newValue has a value other than `undefined`.
      this.newValue = false;
    }

    if (sorterCol.dataType === SorterColumnDataType.USER_MINI) {
      // Load users as items
      const allUsers = this.SDCStore.getAllSchoolUsers();
      this.items = _.sortBy(allUsers, 'lastName');
    }
  }

  columnSearch(searchText) {
    let results = this.columns;
    if (searchText) {
      const filterFunc = this.createFilterFor(searchText);
      results = _.filter(this.columns, filterFunc);
    }
    return results;
  }

  createFilterFor(searchText) {
    return function filterFn(humanName) {
      const humanLower = humanName.toLowerCase();
      const searchLower = searchText.toLowerCase();
      return _.includes(humanLower, searchLower);
    };
  }

  save() {
    this.isSaving = true;
    const selected = this.sorterColumn.getByHumanName(this.selectedColumn);
    const path = selected.path;

    const options = {
      immediate: true,
      bulk: true,
    };

    this.sdcActions
      .updateStudentFieldByPathAsync(this.selectedStudentIds, path, this.newValue, options)
      .catch(function(response) {
        this.ErrorModal.show(response);
      });

    this.isSaving = false;
    this.$mdDialog.hide();
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}

export const NvGridBulkEditorComponent: IComponentOptions = {
  template: require('./nv-grid-bulk-editor.html'),
  controller: NvGridBulkEditorCtrl,
};

angular.module(nvSdcModule).component('nvGridBulkEditor', NvGridBulkEditorComponent);
